module.exports = __webpack_public_path__ + "static/img/one.9fb37d4b.png";